/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { FC } from 'react';
import { SplitFactory, SplitTreatments } from '@splitsoftware/splitio-react';
import config from '../../utils/config';

const splitConfig = {
	core: {
		authorizationKey: config().splitIOApiKey,
		key: 'default',
	},
};

const withSplit =
	(Component: FC): FC =>
	() =>
		(
			<SplitFactory config={splitConfig}>
				<SplitTreatments names={[]}>{({ isReady }: any) => (isReady ? <Component /> : <div id="split-not-ready" />)}</SplitTreatments>
			</SplitFactory>
		);

export default withSplit;
